import React from 'react'
import { getId } from './get-id'

export const Section = ({
    title,
    show,
    setShow,
    cls="medium-header",
    arrowSize="x-large",
    children,
    headerStyle={},
} = {}) => {
    let id = getId()

    return <React.Fragment>

    <h3 className={cls} style={{marginBottom:0, ...headerStyle}}>
        <button
            aria-controls={id}
            style={{position:'relative', top:0, zIndex:1}}
            className="btn-link"
            onClick={() => { setShow(!show) }}
        >
        <i
            style={{color:'var(--primary-base-color)', fontSize:arrowSize}}
            className="toggle-button-icon-open material-icons"
            aria-hidden={true}
        >{
            show ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
        }</i>
        <span
            className="expand-colapse-label"
            aria-expanded={show}>{title}</span>
        </button>
    </h3>

    { !show && <div className="vertical-offset-sm"></div> }

    { show && <div className="vertical-offset-xs"></div> }

    <div id={id} collapsed={show ? "no" : "yes"} className="section-collapsible">
    {children}
    </div>
    </React.Fragment>

}

export const SectionHeader = ({
    title, 
    show, 
    setShow, 
    cls="medium-header", 
    arrowSize="x-large",
    afterTitle=null,
    headerStyle={},
} = {}) => {

    return <React.Fragment>
    <div style={{display:'flex'}}>
    <h3 className={cls} style={{marginBottom:0, ...headerStyle}}>
        <button
            style={{position:'relative', top:0, zIndex:1}}
            className="btn-link"
            aria-expanded={show}
            onClick={() => { setShow(!show) }}
        ><i
            style={{color:'var(--primary-base-color)', fontSize:arrowSize}}
            className="material-icons"
            aria-hidden={true}
        >{
            show ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
        }</i>{title}</button>
    </h3>
    {afterTitle}
    </div>

    { !show && <div className="vertical-offset-sm"></div> }

    { show && <div className="vertical-offset-xs"></div> }

    </React.Fragment>

}

export const SectionBody = ({show, children, className=""}) => {
    return <div
        collapsed={show ? "no" : "yes"}
        className={`section-collapsible ${className}`}
    >{children}</div>

}


// WEBPACK FOOTER //
// ./src/twd/section.js